package com.ijoin.platform.shortcut

actual object ProfileShortcutManager {
    actual fun isSupported(): Boolean = false

    actual fun requestAddShortcut(info: ProfileShortcutInfo): Boolean = false
}
